import * as React from "react";
import { Component } from "react";
import CancelableAxiosInstance from "../../api/CancelableAxiosInstance";
import { AuthManager } from "../auth/AuthContext";
import ImageUtils from "../../util/ImageUtil";

interface ImgProps {
  src: string;
  authManager: AuthManager;
  className?: string;
}

interface ImgState {
  image: string;
}

export default class Img extends Component<ImgProps, ImgState> {
  private client: CancelableAxiosInstance;

  constructor(props: ImgProps) {
    super(props);
    this.client = this.props.authManager.cancelableClient();

    this.state = {
      image: undefined,
    };
  }

  componentDidMount() {
    ImageUtils.downloadImageContent(this.client, this.props.src).then((data) => {
      this.setState({ image: data });
    });
  }

  render() {
    return <img src={this.state.image} className={this.props.className} />;
  }
}
